// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var ContactAgentButton = require("../../common/Agent/ContactAgentButton.bs.js");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var UseShouldShowPropertyDetails = require("../../common/Hooks/UseShouldShowPropertyDetails.bs.js");
var ContactForSalePropertyAgentButton_forSalePropertyV5_graphql = require("../../../__generated__/ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.bs.js");

var convertFragment = ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

var Fragment_membershipStatusV5_decode = ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.Utils.membershipStatusV5_decode;

var Fragment_membershipStatusV5_fromString = ContactForSalePropertyAgentButton_forSalePropertyV5_graphql.Utils.membershipStatusV5_fromString;

var Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ContactForSalePropertyAgentButton$WithoutErrorBoundary(props) {
  var match = use(props.property);
  var agent = match.agentV2;
  var shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(match.fragmentRefs);
  var initiateConversationUrl = "/conversations/new?context_type=property&context_id=" + match.id;
  var exit = 0;
  if (shouldShowPropertyDetails) {
    switch (agent.__typename) {
      case "AnonymousForSalePropertyAgent" :
      case "VisibleForSalePropertyAgent" :
          exit = 2;
          break;
      case "__unselected" :
          return UnselectedUnionMemberError.raise("Unselected for sale property agent " + agent._0);
      
    }
  } else {
    exit = 2;
  }
  if (exit === 2) {
    switch (agent.__typename) {
      case "AnonymousForSalePropertyAgent" :
          var tmp = agent.membershipStatus;
          if ((tmp === "ACTIVE" || tmp === "TERMINATED") && tmp !== "ACTIVE") {
            return null;
          }
          break;
      case "VisibleForSalePropertyAgent" :
          var tmp$1 = agent.agent.membershipStatus;
          if ((tmp$1 === "ACTIVE" || tmp$1 === "TERMINATED") && tmp$1 !== "ACTIVE") {
            return null;
          }
          break;
      case "__unselected" :
          break;
      
    }
  }
  if (shouldShowPropertyDetails) {
    if (agent.__typename === "AnonymousForSalePropertyAgent") {
      return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  href: initiateConversationUrl,
                  size: "small",
                  children: "Contact agent"
                });
    } else {
      return JsxRuntime.jsx(ContactAgentButton.make, {
                  agent: agent.agent.fragmentRefs,
                  onInitiateConversation: {
                    TAG: "Navigate",
                    _0: initiateConversationUrl
                  },
                  position: props.position
                });
    }
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                      disabled: true,
                      size: "small",
                      overlayText: "Pro Only",
                      children: "Contact agent"
                    }),
                className: "z-[1]"
              });
  }
}

var WithoutErrorBoundary = {
  make: ContactForSalePropertyAgentButton$WithoutErrorBoundary
};

function ContactForSalePropertyAgentButton(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "agent information",
              children: JsxRuntime.jsx(ContactForSalePropertyAgentButton$WithoutErrorBoundary, {
                    property: props.property,
                    position: props.position
                  })
            });
}

var make = ContactForSalePropertyAgentButton;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* ButtonsV5 Not a pure module */
